import type { PayloadAction } from '@reduxjs/toolkit';
import { SelectedDateState } from './selectedDateInterface';

export const selectedDate = (
  state: SelectedDateState,
  action: PayloadAction<Partial<SelectedDateState>>,
) => {
  return { ...state, ...action.payload };
};
